module.exports = __webpack_public_path__ + "img/sv74on.d47316e7.svg";